<template>
  <FormularioCadastro
    module-name="Tipo de Produto/Serviço"
    :is-loading="isSaving"
    :is-editing="isEditing"
    :entity-info="entityInfo"
    @submit="submitFormPrincipal"
    @cancelar="handleCancel"
    @show-notification="(p) => emit('show-notification', p)"
    :ocultar-salvar="!isTipoProdutoSaved"
    label-botao-adicionar="Salvar Tipo de Produto"
  >
    <template #acoes-header v-if="isEditing">
      <button
        type="button"
        class="btn-icon-minimalista me-3"
        @click="abrirAuditoria"
        title="Ver Histórico de Alterações"
      >
        <i class="bi bi-clock-history"></i>
      </button>
    </template>

    <!-- Banner de bloqueio por produtos vinculados -->
    <div v-if="isTipoProdutoBloqueado" class="alert alert-warning border-0 rounded-3 mb-4 d-flex align-items-center">
      <i class="bi bi-lock-fill fs-4 me-3 text-warning"></i>
      <div><strong>Registro Bloqueado:</strong> Este Tipo de Produto possui produtos vinculados. Apenas o Status pode ser alterado. Para gerenciar listas auxiliares, utilize o botão de adicionar listas.</div>
    </div>

    <!-- FRAME 1: DADOS BÁSICOS -->
    <div class="card mb-3">
      <div class="card-header d-flex justify-content-between align-items-center pointer" @click="toggleAccordion('basico')">
        <h5 class="mb-0"><i class="bi bi-box-seam me-2"></i>Configurações Gerais</h5>
        <i class="bi" :class="accordionState.basico ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </div>

      <div v-show="accordionState.basico" class="card-body">
        <div class="row g-3">
          <div class="col-md-3">
            <CampoSelect
              id="lstNaturezaItem"
              label="Natureza do Item"
              v-model="item.lstNaturezaItem"
              :options="listas.LstNaturezaItem || []"
              option-value="idListaClienteItem"
              option-label="textoLista"
              required
              :disabled="isTipoProdutoBloqueado"
            />
          </div>
          <div class="col-md-3">
            <CampoSelect
              id="lstTipoItemSped"
              label="Tipo do Item (SPED)"
              v-model="item.lstTipoItemSped"
              :options="listas.LstTipoItemSped || []"
              option-value="idListaClienteItem"
              option-label="textoLista"
              :disabled="isTipoProdutoBloqueado"
            >
              <template #label>
                Tipo do Item (SPED)
                <i class="bi bi-info-circle ms-1" title="Campo TIPO_ITEM do registro 0200 da EFD ICMS/IPI. Opcional no cadastro; usado na geração do arquivo SPED."></i>
              </template>
            </CampoSelect>
          </div>
          <div class="col-md-3">
            <CampoInput
              id="descricaoBreve"
              label="Descrição Breve"
              v-model="item.descricaoBreve"
              placeholder="Ex: Revenda"
              maxlength="20"
              required
              :readonly="isTipoProdutoBloqueado"
            />
          </div>
          <div class="col-md-6">
            <CampoInput
              id="descricao"
              label="Descrição Completa"
              v-model="item.descricao"
              placeholder="Detalhamento (Opcional)"
              maxlength="200"
              :readonly="isTipoProdutoBloqueado"
            />
          </div>

          <div class="col-md-2">
            <CampoSelect
              id="compravel"
              label="Comprável?"
              v-model="item.compravel"
              :options="simNaoOptions"
              option-value="id"
              option-label="label"
              required
              :disabled="isTipoProdutoBloqueado"
            />
          </div>
          <div class="col-md-3">
            <CampoSelect
              id="permiteConversaoVariavel"
              v-model="item.permiteConversaoVariavel"
              :options="simNaoOptions"
              option-value="id"
              option-label="label"
              required
              :disabled="isTipoProdutoBloqueado || item.lstNaturezaItem === PROD_NATUREZA.Servico || !parseBool(item.compravel)"
            >
              <template #label>
                Permite Conversão Variável?
                <i
                  class="bi bi-info-circle ms-1"
                  title="Significa que o produto não terá conversão direta e automática pela unidade de medida do fornecedor, em operações de compra."
                ></i>
              </template>
            </CampoSelect>
          </div>
          <div class="col-md-4">
            <!-- Miniframe: Destinação de Uso -->
            <div
              class="p-3 rounded-3 border h-100"
              :class="!isTipoProdutoBloqueado ? 'bg-light-subtle border-primary-subtle' : 'bg-body-tertiary border-secondary-subtle opacity-50'"
            >
              <div class="d-flex align-items-center mb-2">
                <i class="bi bi-signpost-split me-2" :class="!isTipoProdutoBloqueado ? 'text-primary' : 'text-secondary'"></i>
                <span class="small fw-semibold" :class="!isTipoProdutoBloqueado ? 'text-primary' : 'text-secondary'">
                  Destinação de Uso
                </span>
                <span v-if="isTipoProdutoBloqueado" class="badge bg-secondary ms-2" style="font-size: 0.65rem;">BLOQUEADO</span>
                <span v-else class="badge bg-primary ms-2" style="font-size: 0.65rem;">ATIVO</span>
              </div>
              <div class="d-flex flex-wrap gap-4 pt-1 justify-content-center">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="comercializavel"
                    :checked="item.comercializavel"
                    @change="setClassificacao('comercializavel')"
                    :disabled="isTipoProdutoBloqueado"
                    id="radioComercializavel"
                  />
                  <label class="form-check-label" for="radioComercializavel">Comercializável</label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="industrializacao"
                    :checked="item.industrializacao"
                    @change="setClassificacao('industrializacao')"
                    :disabled="isTipoProdutoBloqueado"
                    id="radioIndustrializacao"
                  />
                  <label class="form-check-label" for="radioIndustrializacao">Industrialização</label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="consumo"
                    :checked="item.consumo"
                    @change="setClassificacao('consumo')"
                    :disabled="isTipoProdutoBloqueado"
                    id="radioConsumo"
                  />
                  <label class="form-check-label" for="radioConsumo">Consumo</label>
                </div>
              </div>
            </div>
          </div>
          <!-- Margem Esperada (sempre visível; bloqueada quando não comercializável) -->
          <div class="col-md-2">
            <CampoInput
              id="margemEsperadaPercentual"
              label="Margem Esperada (%)"
              type="decimal"
              :casas-decimais="2"
              min="0"
              max="100"
              v-model.number="item.margemEsperadaPercentual"
              :disabled="isTipoProdutoBloqueado || !parseBool(item.comercializavel)"
            />
          </div>

          <!-- Quebra de linha: os controles de estoque descem para antes do Status -->
          <div class="w-100"></div>

          <div class="col-md-2">
            <CampoSelect
              id="controlaEstoque"
              label="Controla Estoque?"
              v-model="item.controlaEstoque"
              :options="simNaoOptions"
              option-value="id"
              option-label="label"
              required
              :disabled="isTipoProdutoBloqueado || item.lstNaturezaItem === PROD_NATUREZA.Servico"
            />
          </div>
          <div class="col-md-2">
            <CampoSelect
              id="controlaLote"
              label="Controla Lote?"
              v-model="item.controlaLote"
              :options="simNaoOptions"
              option-value="id"
              option-label="label"
              required
              :disabled="isTipoProdutoBloqueado || item.lstNaturezaItem === PROD_NATUREZA.Servico || !parseBool(item.controlaEstoque)"
            />
          </div>
          <div class="col-md-3">
            <CampoSelect
              id="gerirEstoquePorUnidadeLogistica"
              v-model="item.gerirEstoquePorUnidadeLogistica"
              :options="simNaoOptions"
              option-value="id"
              option-label="label"
              required
              :disabled="isTipoProdutoBloqueado || item.lstNaturezaItem === PROD_NATUREZA.Servico || !parseBool(item.controlaEstoque)"
            >
              <template #label>
                Gerir Estoque por Unidade Logística?
                <i
                  class="bi bi-info-circle ms-1"
                  title="Todo movimento de estoque será baseado na unidade logística, com Catch Weight. ex.: Big bag, Bundle"
                ></i>
              </template>
            </CampoSelect>
          </div>
          <div class="col-md-3">
            <CampoSelect
              id="lstStatus"
              label="Status"
              v-model="item.lstStatus"
              :options="listas.status"
              option-value="idListaSistemaItem"
              option-label="textoLista"
              required
            />
          </div>
        </div>
      </div>
    </div>

    <!-- FRAME 2: MOTOR DE GERAÇÃO DE SKU -->
    <div class="card mb-3">
      <div class="card-header d-flex justify-content-between align-items-center pointer bg-primary-subtle" @click="toggleAccordion('sku')">
        <h5 class="mb-0 text-primary-emphasis"><i class="bi bi-upc-scan me-2"></i>Regras de Geração de Código (SKU)</h5>
        <i class="bi text-primary-emphasis" :class="accordionState.sku ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </div>

      <div v-show="accordionState.sku" class="card-body border-top border-primary-subtle">
        <div class="alert alert-info border-0 shadow-sm small py-2 mb-4 d-flex align-items-center">
          <i class="bi bi-info-circle-fill me-2 fs-5"></i>
          <span>Configure como o código interno (SKU) será definido quando o usuário cadastrar um produto desta categoria.</span>
        </div>

        <div class="row g-3">
          <div class="col-md-4">
            <CampoSelect
              id="formatoGeracaoSku"
              label="Formato do SKU"
              v-model="item.formatoGeracaoSku"
              :options="opcoesFormatoSku"
              option-value="id"
              option-label="label"
              required
              :disabled="isTipoProdutoBloqueado"
            />
          </div>

          <template v-if="item.formatoGeracaoSku !== 'MANUAL'">
            <div class="col-md-2">
              <CampoInput
                id="separadorCodigo"
                label="Separador"
                v-model="item.separadorCodigo"
                placeholder="Ex: - ou /"
                maxlength="5"
                :readonly="isTipoProdutoBloqueado"
              />
            </div>
          </template>

          <template v-if="item.formatoGeracaoSku === 'SEQUENCIAL'">
            <div class="col-md-3">
              <CampoInput
                id="prefixoSequencial"
                label="Prefixo Base"
                v-model="item.prefixoSequencial"
                placeholder="Ex: PROD"
                maxlength="10"
                @input="item.prefixoSequencial = item.prefixoSequencial.toUpperCase()"
                :readonly="isTipoProdutoBloqueado"
              />
            </div>
            <div class="col-md-3">
              <CampoInput
                id="tamanhoSequencial"
                label="Qtd Zeros (Esquerda)"
                type="number"
                min="0"
                max="10"
                v-model.number="item.tamanhoSequencial"
                placeholder="Ex: 6 para 000001"
                :readonly="isTipoProdutoBloqueado"
              />
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- FRAME 3: INTEGRAÇÃO FINANCEIRA -->
    <div class="card mb-3">
      <div class="card-header d-flex justify-content-between align-items-center pointer bg-success-subtle" @click="toggleAccordion('financeiro')">
        <h5 class="mb-0 text-success-emphasis"><i class="bi bi-cash-coin me-2"></i>Integração Financeira</h5>
        <i class="bi text-success-emphasis" :class="accordionState.financeiro ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </div>

      <div v-show="accordionState.financeiro" class="card-body border-top border-success-subtle">
        <div class="alert alert-success border-0 shadow-sm small py-2 mb-4 d-flex align-items-center">
          <i class="bi bi-info-circle-fill me-2 fs-5"></i>
          <span>Defina as categorias financeiras padrão para as operações de entrada (receitas) e saída (despesas) deste tipo de produto. Estas configurações serão herdadas pelo produto.</span>
        </div>

        <div class="row g-3">
          <div class="col-md-4">
            <CampoBusca
              id="idCategoriaFinanceiraEntrada"
              label="Categoria Financeira Padrão (Entradas/Receitas)"
              v-model="item.idCategoriaFinanceiraEntrada"
              :configuracao-busca="confBuscaCatEntrada"
              :required="parseBool(item.comercializavel)"
              :desabilitar="isTipoProdutoBloqueado"
              @selecionado="val => {
                item.categoriaFinanceiraEntradaCodigo = val.codigoEstruturado
                item.categoriaFinanceiraEntradaNome = val.nome
                delete formErrors.idCategoriaFinanceiraEntrada
              }"
              @show-notification="p => emit('show-notification', p)"
            />
          </div>
          <div class="col-md-4">
            <CampoBusca
              id="idCategoriaFinanceiraSaida"
              label="Categoria Financeira Padrão (Saídas/Despesas)"
              v-model="item.idCategoriaFinanceiraSaida"
              :configuracao-busca="confBuscaCatSaida"
              :required="parseBool(item.compravel)"
              :desabilitar="isTipoProdutoBloqueado"
              @selecionado="val => {
                item.categoriaFinanceiraSaidaCodigo = val.codigoEstruturado
                item.categoriaFinanceiraSaidaNome = val.nome
                delete formErrors.idCategoriaFinanceiraSaida
              }"
              @show-notification="p => emit('show-notification', p)"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Botão Salvar Tipo e Liberar Listas (apenas criação) -->
    <div class="mb-4" v-if="!isTipoProdutoSaved">
      <button
        type="button"
        class="btn btn-success px-4"
        @click="salvarTipoProdutoLocal"
        :disabled="isSavingTipoLocal || !item.lstNaturezaItem || !item.descricaoBreve || !item.lstStatus"
      >
        <span v-if="isSavingTipoLocal" class="spinner-border spinner-border-sm me-2"></span>
        <i v-else class="bi bi-save me-2"></i>
        Salvar Tipo de Produto e Liberar Listas
      </button>
    </div>

    <!-- FRAME 4: LISTAS VINCULADAS -->
    <div :class="{ 'pe-none opacity-50': isListasFrameBlocked }">
    <div class="card mb-3">
      <div class="card-header d-flex justify-content-between align-items-center pointer" @click="toggleAccordion('listas')">
        <h5 class="mb-0"><i class="bi bi-list-check me-2"></i>Listas Auxiliares (Atributos Comerciais)</h5>
        <i class="bi" :class="accordionState.listas ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </div>
      <div v-show="accordionState.listas" class="card-body border-top border-secondary-subtle p-0">
        <!-- Guardião: Tipo não salvo -->
        <div v-if="isListasFrameBlocked" class="text-center text-muted py-4">
          <i class="bi bi-info-circle me-2"></i>
          Salve o Tipo de Produto primeiro para gerenciar as listas auxiliares.
        </div>

        <div v-else class="admin-table-container border-0 shadow-none mb-0">
          <table class="table admin-table align-middle m-0">
            <thead>
              <tr>
                <th style="width: 80px;">ID</th>
                <th>Nome / Descrição da Lista</th>
                <th style="width: 150px;">Prefixo</th>
                <th class="text-center" style="width: 150px;" title="Disponível apenas para SKU por Atributos">Compõe SKU?</th>
                <th class="text-end" style="width: 80px;">
                  <button type="button" class="btn btn-sm btn-primary py-0" @click.stop="abrirModalBusca" :disabled="isSavingListaVinculada">
                    <span v-if="isSavingListaVinculada" class="spinner-border spinner-border-sm"></span>
                    <i v-else class="bi bi-plus-lg"></i>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(vinc, idx) in item.listasVinculadas" :key="idx">
                <td class="text-body-secondary small">{{ vinc.prefixoItemLista }}</td>
                <td>
                  <div class="d-flex align-items-center">
                    <i class="bi bi-list-ul text-primary me-2 fs-5"></i>
                    <div>
                      <span class="fw-bold d-block text-body-emphasis">{{ obterDadosLista(vinc.prefixoItemLista, 'nomeLista') }}</span>
                      <small class="text-body-secondary">{{ obterDadosLista(vinc.prefixoItemLista, 'descricaoLista') }}</small>
                    </div>
                  </div>
                </td>
                <td>
                  <code class="badge bg-body-secondary text-body border border-secondary-subtle fw-normal">
                    {{ vinc.prefixoItemLista }}
                  </code>
                </td>
                <td class="text-center">
                  <div class="form-check d-flex justify-content-center">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :checked="vinc.compoeCodigoProduto"
                      :disabled="item.formatoGeracaoSku !== 'ATRIBUTOS'"
                      @change="atualizarCompoeCodigo(vinc, $event.target.checked)"
                    >
                  </div>
                </td>
                <td class="acoes-cell text-end pe-3">
                  <button
                    type="button"
                    class="btn-icon text-danger"
                    @click="excluirListaVinculada(vinc, idx)"
                    title="Remover Vínculo"
                    :disabled="isTipoProdutoBloqueado || isSavingListaVinculada"
                  >
                    <i class="bi bi-trash-fill"></i>
                  </button>
                </td>
              </tr>
              <tr v-if="!item.listasVinculadas || item.listasVinculadas.length === 0">
                <td colspan="5" class="text-center py-4 text-muted fst-italic">
                  <i class="bi bi-info-circle me-1"></i>Nenhuma lista vinculada a este tipo de produto.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>

    <!-- MODAL DE SELEÇÃO DE LISTA -->
    <ModalDeBusca
      v-if="mostrarModalBuscaLista"
      :configuracao="configBuscaLista"
      @item-selecionado="onListaSelecionadaModal"
      @fechar="mostrarModalBuscaLista = false"
    />
  </FormularioCadastro>

  <!-- AUDITORIA -->
  <AuditLogViewer
    v-if="mostrarAuditoria"
    tabela="TipoProduto"
    :chave-primaria="item.idTipoProduto"
    :tabelas-filhas="['TipoProdutoLista']"
    chave-estrangeira="IdTipoProduto"
    :titulo-registro="item.descricaoBreve || 'Tipo de Produto'"
    :dicionarios="{
      'lstStatus': listas.status,
      'status': listas.status
    }"
    @fechar="mostrarAuditoria = false"
  />
</template>

<script setup>
import { ref, reactive, onMounted, computed, watch, provide } from 'vue'
import { useFormulario } from '@/composables/useFormulario'
import { useAuthStore } from '@/stores/auth'
import { useMetadataListasStore } from '@/stores/metadataListas'
import { ST } from '@/constants/ST'
import { CATFIN_TP_MOV } from '@/constants/CATFIN_TP_MOV'
import { FIN_ST_PLAN_CATEGFIN } from '@/constants/FIN_ST_PLAN_CATEGFIN'
import { PROD_NATUREZA } from '@/constants/PROD_NATUREZA'
import { criarConfigBuscaCategoriaFinanceira } from '@/search-definitions/categoriaFinanceiraSearch'
import api from '@/services/api'
import FormularioCadastro from '@/components/base/formulario/FormularioCadastro.vue'
import CampoInput from '@/components/base/campos/CampoInput.vue'
import CampoSelect from '@/components/base/campos/CampoSelect.vue'
import CampoBusca from '@/components/base/campos/CampoBusca.vue'
import ModalDeBusca from '@/components/base/modal/ModalDeBusca.vue'
import AuditLogViewer from '@/components/base/auditoria/AuditLogViewer.vue'

const props = defineProps({
  itemParaEditar: { type: Object, default: null }
})

const emit = defineEmits(['itemAtualizado', 'cancelar', 'show-notification', 'changesDetected'])

const authStore = useAuthStore()

const mapaCampos = {
  lstNaturezaItem: 'Natureza do Item',
  descricaoBreve: 'Descrição Breve',
  descricao: 'Descrição Completa',
  comercializavel: 'Comercializável',
  industrializacao: 'Industrialização',
  consumo: 'Consumo',
  compravel: 'Comprável',
  controlaEstoque: 'Controla Estoque',
  controlaLote: 'Controla Lote',
  permiteConversaoVariavel: 'Permite Conversão Variável',
  gerirEstoquePorUnidadeLogistica: 'Gerir Estoque por Unidade Logística',
  margemEsperadaPercentual: 'Margem Esperada',
  lstStatus: 'Status',
  formatoGeracaoSku: 'Formato do SKU',
  idCategoriaFinanceiraEntrada: 'Categoria Financeira (Entradas)',
  idCategoriaFinanceiraSaida: 'Categoria Financeira (Saídas)'
}

const { item, isLoading: isSaving, isEditing, entityInfo, submitForm, handleCancel } = useFormulario(props, emit, { mapaCampos })

// --- Validação reativa via provide/inject (para CampoBusca) ---
const formErrors = ref({})
provide('formErrors', formErrors)

// --- Plano de Categoria Financeira vigente ---
const idPlanoCategoriaFinanceira = ref(null)

/** Resolve o plano de categoria financeira ativo e vigente para a data atual */
const resolverPlanoCategoria = async () => {
  try {
    const res = await api.get('/PlanosCategoriasFinanceiras', {
      params: {
        lstStatusPlano: FIN_ST_PLAN_CATEGFIN.Ativo,
        idEmpresa: authStore.empresaAtiva,
        pageSize: 50
      }
    })
    const hoje = new Date()
    const plano = (res.data || []).find(p => {
      if (!p.dataInicioVigencia || !p.dataFimVigencia) return false
      const inicio = new Date(p.dataInicioVigencia + 'T00:00:00')
      const fim = new Date(p.dataFimVigencia + 'T00:00:00')
      return hoje >= inicio && hoje <= fim
    })
    idPlanoCategoriaFinanceira.value = plano ? plano.idPlanoCategoriaFinanceira : null
    if (!idPlanoCategoriaFinanceira.value) {
      console.warn('[TiposProdutoCadastro] Nenhum plano ativo vigente encontrado para a data atual.')
    }
  } catch (e) {
    console.warn('[TiposProdutoCadastro] Erro ao resolver plano vigente:', e)
    idPlanoCategoriaFinanceira.value = null
  }
}

// --- Estado do Modal de Auditoria ---
const mostrarAuditoria = ref(false)
const abrirAuditoria = () => {
  mostrarAuditoria.value = true
}

// --- Lógica de "Salvar e Liberar Listas" ---
const isTipoProdutoSaved = ref(isEditing.value)
const isSavingTipoLocal = ref(false)
const isListasFrameBlocked = computed(() => !isTipoProdutoSaved.value)

// --- Bloqueio por produtos vinculados ---
const temProdutosVinculados = ref(false)
const isTipoProdutoBloqueado = computed(() => {
  return isEditing.value && temProdutosVinculados.value
})

// --- Estado Local e UI ---
const accordionState = reactive({
  basico: true,
  sku: true,
  financeiro: true,
  listas: true
})

const metadataStore = useMetadataListasStore()

const listas = reactive({
  status: [],
  listasCliente: [],
  LstNaturezaItem: [],
  LstTipoItemSped: []
})

const mostrarModalBuscaLista = ref(false)
const isSavingListaVinculada = ref(false)

const simNaoOptions = [
  { id: true, label: 'Sim' },
  { id: false, label: 'Não' }
]

const opcoesFormatoSku = [
  { id: 'MANUAL', label: 'Digitação Manual Livre' },
  { id: 'SEQUENCIAL', label: 'Gerado Sequencialmente' },
  { id: 'ATRIBUTOS', label: 'Formado por Atributos' }
]

// --- Lógica: Integração Financeira (Campo Busca Genérico) ---
const confBuscaCatEntrada = computed(() =>
  criarConfigBuscaCategoriaFinanceira(
    'Pesquisar Categoria Financeira (Entrada)',
    CATFIN_TP_MOV.Receita,
    ST.Ativo,
    authStore.organizacaoAtiva,
    null,
    idPlanoCategoriaFinanceira.value,
    true
  )
)

const confBuscaCatSaida = computed(() =>
  criarConfigBuscaCategoriaFinanceira(
    'Pesquisar Categoria Financeira (Saída)',
    `${CATFIN_TP_MOV.Custo},${CATFIN_TP_MOV.Despesa},${CATFIN_TP_MOV.Imposto}`,
    ST.Ativo,
    authStore.organizacaoAtiva,
    null,
    idPlanoCategoriaFinanceira.value,
    true
  )
)

// --- Bloqueio estrito de stock e lote para Serviços ---
watch(() => item.value.lstNaturezaItem, (novaNatureza) => {
  if (novaNatureza === PROD_NATUREZA.Servico) {
    item.value.controlaEstoque = false
    item.value.controlaLote = false
    item.value.permiteConversaoVariavel = false
    item.value.gerirEstoquePorUnidadeLogistica = false
  }
})

// --- Limpa campos dependentes quando Comprável for Não ---
watch(() => item.value.compravel, (val) => {
  if (!parseBool(val)) {
    item.value.permiteConversaoVariavel = null
  }
})

// --- Limpa campos dependentes quando Controla Estoque for Não ---
watch(() => item.value.controlaEstoque, (val) => {
  if (!parseBool(val)) {
    item.value.controlaLote = null
    item.value.gerirEstoquePorUnidadeLogistica = null
  }
})

// --- Reset de checkboxes das listas se SKU não for Atributos ---
watch(() => item.value.formatoGeracaoSku, (novoFormato) => {
  if (novoFormato !== 'ATRIBUTOS' && item.value.listasVinculadas) {
    item.value.listasVinculadas.forEach(l => {
      l.compoeCodigoProduto = false
    })
  }
})

// --- Lógica: Adição de Listas via Modal ---
const configBuscaLista = computed(() => ({
  titulo: 'Pesquisar Lista Personalizada',
  endpointApi: 'ListasCliente',
  idField: 'prefixoItemLista',
  camposFiltro: [
    { model: 'nomeLista', label: 'Nome da Lista', tipo: 'text' },
    { model: 'idEmpresa', label: 'Empresa', tipo: 'hidden', value: authStore.empresaAtiva }
  ],
  colunasGrid: [
    { header: 'Prefixo', dataField: 'prefixoItemLista', width: '30%' },
    { header: 'Nome da Lista', dataField: 'nomeLista', width: '55%' },
    { header: 'ID', dataField: 'prefixoItemLista', width: '15%' }
  ]
}))

if (!props.itemParaEditar) {
  item.value = {
    idTipoProduto: 0,
    idOrganizacao: null,
    lstNaturezaItem: null,
    descricaoBreve: '',
    descricao: '',
    comercializavel: null,
    industrializacao: null,
    consumo: null,
    compravel: null,
    controlaEstoque: null,
    controlaLote: null,
    permiteConversaoVariavel: null,
    gerirEstoquePorUnidadeLogistica: null,
    margemEsperadaPercentual: null,
    lstStatus: null,
    idCategoriaFinanceiraEntrada: null,
    categoriaFinanceiraEntradaCodigo: '',
    categoriaFinanceiraEntradaNome: '',
    idCategoriaFinanceiraSaida: null,
    categoriaFinanceiraSaidaCodigo: '',
    categoriaFinanceiraSaidaNome: '',
    formatoGeracaoSku: null,
    separadorCodigo: '',
    prefixoSequencial: '',
    tamanhoSequencial: null,
    listasVinculadas: []
  }
}

function toggleAccordion (key) {
  accordionState[key] = !accordionState[key]
}

function definirDefaults () {
  if (props.itemParaEditar) return
  item.value.lstStatus = null
}

async function carregarListas () {
  try {
    const [resStatus, resListas, metadataResult] = await Promise.all([
      api.get('/ListasSistema/lookup/ST'),
      api.get('/ListasCliente?pageSize=1000'),
      metadataStore.carregarListasParaTabelas(['TipoProduto'])
    ])

    listas.status = resStatus.data
    listas.listasCliente = Array.isArray(resListas.data) ? resListas.data : (resListas.data?.items || [])
    Object.assign(listas, metadataResult)

    definirDefaults()
  } catch (error) {
    emit('show-notification', { message: 'Erro ao carregar listas auxiliares.', type: 'error' })
  }
}

function abrirModalBusca () {
  mostrarModalBuscaLista.value = true
}

async function onListaSelecionadaModal (listaObj) {
  mostrarModalBuscaLista.value = false

  if (!listaObj) return

  const prefixoLista = listaObj.prefixoItemLista

  if (!prefixoLista) {
    emit('show-notification', { message: 'A lista selecionada não possui um prefixo válido.', type: 'error' })
    return
  }

  // Verifica duplicidade no frontend
  if ((item.value.listasVinculadas || []).find(l => l.prefixoItemLista === prefixoLista)) {
    emit('show-notification', { message: 'Esta lista já está vinculada a este Tipo de Produto.', type: 'warning' })
    return
  }

  // Se o tipo já está salvo, persiste via endpoint independente
  if (isTipoProdutoSaved.value && item.value.idTipoProduto) {
    isSavingListaVinculada.value = true
    try {
      const response = await api.post('/TiposProdutoListas', {
        idTipoProduto: item.value.idTipoProduto,
        prefixoItemLista: prefixoLista,
        compoeCodigoProduto: false
      })
      if (!item.value.listasVinculadas) {
        item.value.listasVinculadas = []
      }
      item.value.listasVinculadas.push({
        idTipoProdutoLista: response.data.idTipoProdutoLista,
        prefixoItemLista: response.data.prefixoItemLista,
        compoeCodigoProduto: response.data.compoeCodigoProduto
      })
      emit('show-notification', { message: 'Lista vinculada com sucesso.', type: 'success' })
    } catch (error) {
      const msg = error.response?.data?.message || 'Erro ao vincular lista.'
      emit('show-notification', { message: msg, type: 'error' })
    } finally {
      isSavingListaVinculada.value = false
    }
    return
  }

  // Modo criação: adiciona localmente (será enviada no POST)
  if (!item.value.listasVinculadas) {
    item.value.listasVinculadas = []
  }
  item.value.listasVinculadas.push({
    prefixoItemLista: prefixoLista,
    compoeCodigoProduto: false
  })

  emit('changesDetected', true)
}

async function excluirListaVinculada (vinc, idx) {
  if (isTipoProdutoBloqueado.value) {
    emit('show-notification', { message: 'Não é possível remover listas auxiliares de um Tipo de Produto com produtos vinculados.', type: 'warning' })
    return
  }

  // Se já persiste no backend, exclui via endpoint
  if (vinc.idTipoProdutoLista) {
    isSavingListaVinculada.value = true
    try {
      await api.delete(`/TiposProdutoListas/${vinc.idTipoProdutoLista}`)
      item.value.listasVinculadas.splice(idx, 1)
      emit('show-notification', { message: 'Lista desvinculada com sucesso.', type: 'success' })
    } catch (error) {
      const msg = error.response?.data?.message || 'Erro ao remover lista vinculada.'
      emit('show-notification', { message: msg, type: 'error' })
    } finally {
      isSavingListaVinculada.value = false
    }
    return
  }

  // Apenas local (modo criação)
  item.value.listasVinculadas.splice(idx, 1)
}

async function atualizarCompoeCodigo (vinc, checked) {
  vinc.compoeCodigoProduto = checked

  // Se já persiste, atualiza via endpoint
  if (vinc.idTipoProdutoLista) {
    try {
      await api.put(`/TiposProdutoListas/${vinc.idTipoProdutoLista}`, {
        idTipoProduto: item.value.idTipoProduto,
        prefixoItemLista: vinc.prefixoItemLista,
        compoeCodigoProduto: checked
      })
    } catch (error) {
      const msg = error.response?.data?.message || 'Erro ao atualizar composição de código.'
      emit('show-notification', { message: msg, type: 'error' })
    }
  }
}

// --- Limpa formErrors quando os campos de categoria são preenchidos ou os selects mudam ---
watch(() => item.value.idCategoriaFinanceiraEntrada, (val) => {
  if (val) {
    delete formErrors.value.idCategoriaFinanceiraEntrada
  } else {
    item.value.categoriaFinanceiraEntradaCodigo = ''
    item.value.categoriaFinanceiraEntradaNome = ''
  }
})
watch(() => item.value.idCategoriaFinanceiraSaida, (val) => {
  if (val) {
    delete formErrors.value.idCategoriaFinanceiraSaida
  } else {
    item.value.categoriaFinanceiraSaidaCodigo = ''
    item.value.categoriaFinanceiraSaidaNome = ''
  }
})
watch(() => item.value.comercializavel, () => {
  delete formErrors.value.idCategoriaFinanceiraEntrada
})
watch(() => item.value.compravel, () => {
  delete formErrors.value.idCategoriaFinanceiraSaida
})

function obterDadosLista (prefixo, field) {
  const listaEncontrada = listas.listasCliente.find(l => l.prefixoItemLista === prefixo)
  if (listaEncontrada) return listaEncontrada[field]

  if (field === 'nomeLista') return `Lista: ${prefixo}`
  return '...'
}

// --- Submissão ---
const parseBool = (val) => val === true || String(val) === 'true'

function setClassificacao (tipo) {
  item.value.comercializavel = tipo === 'comercializavel'
  item.value.industrializacao = tipo === 'industrializacao'
  item.value.consumo = tipo === 'consumo'
}

function montarPayload () {
  return {
    ...item.value,
    comercializavel: parseBool(item.value.comercializavel),
    industrializacao: parseBool(item.value.industrializacao),
    consumo: parseBool(item.value.consumo),
    compravel: parseBool(item.value.compravel),
    controlaEstoque: item.value.lstNaturezaItem === PROD_NATUREZA.Servico ? false : parseBool(item.value.controlaEstoque),
    controlaLote: item.value.lstNaturezaItem === PROD_NATUREZA.Servico ? false : parseBool(item.value.controlaLote),
    permiteConversaoVariavel: item.value.lstNaturezaItem === PROD_NATUREZA.Servico ? false : parseBool(item.value.permiteConversaoVariavel),
    gerirEstoquePorUnidadeLogistica: item.value.lstNaturezaItem === PROD_NATUREZA.Servico ? false : parseBool(item.value.gerirEstoquePorUnidadeLogistica),
    margemEsperadaPercentual: item.value.margemEsperadaPercentual ?? null,
    tamanhoSequencial: item.value.tamanhoSequencial ? Number(item.value.tamanhoSequencial) : null,

    idCategoriaFinanceiraEntrada: item.value.idCategoriaFinanceiraEntrada || null,
    idCategoriaFinanceiraSaida: item.value.idCategoriaFinanceiraSaida || null,

    listasVinculadas: (item.value.listasVinculadas || []).filter(l => !l.idTipoProdutoLista).map(l => ({
      prefixoItemLista: l.prefixoItemLista,
      compoeCodigoProduto: parseBool(l.compoeCodigoProduto)
    }))
  }
}

async function salvarTipoProdutoLocal () {
  // Validação: ao menos uma classificação comercial deve estar selecionada
  if (!parseBool(item.value.comercializavel) && !parseBool(item.value.industrializacao) && !parseBool(item.value.consumo)) {
    emit('show-notification', {
      message: 'Selecione uma classificação comercial: Comercializável, Industrialização ou Consumo.',
      type: 'warning'
    })
    return
  }

  // Validação: ao menos um entre Comercializável, Comprável ou Controla Estoque precisa ser Sim
  if (!parseBool(item.value.comercializavel) && !parseBool(item.value.compravel) && !parseBool(item.value.controlaEstoque)) {
    emit('show-notification', {
      message: 'Ao menos um dos campos (Comercializável, Comprável ou Controla Estoque) deve ser selecionado como SIM.',
      type: 'warning'
    })
    return
  }

  if (authStore.isAdminInterno && !authStore.empresaAtiva) {
    emit('show-notification', { message: 'Selecione uma empresa no topo antes de salvar.', type: 'warning' })
    return
  }

  isSavingTipoLocal.value = true
  try {
    const payload = montarPayload()
    const response = await api.post('/TiposProduto', payload)
    item.value = response.data
    isTipoProdutoSaved.value = true
    isEditing.value = true
    entityInfo.value = `Editando ID: ${item.value.idTipoProduto}`
    emit('show-notification', { message: 'Tipo de Produto salvo. Agora pode adicionar listas auxiliares.', type: 'success' })
    accordionState.listas = true
  } catch (error) {
    const data = error.response?.data
    const msg = data?.message || 'Erro ao salvar o Tipo de Produto.'
    emit('show-notification', { message: msg, type: 'error' })
  } finally {
    isSavingTipoLocal.value = false
  }
}

async function submitFormPrincipal () {
  // Validação: ao menos uma classificação comercial deve estar selecionada
  if (!parseBool(item.value.comercializavel) && !parseBool(item.value.industrializacao) && !parseBool(item.value.consumo)) {
    emit('show-notification', {
      message: 'Selecione uma classificação comercial: Comercializável, Industrialização ou Consumo.',
      type: 'warning'
    })
    return
  }

  // Validação igual à original
  if (!parseBool(item.value.comercializavel) && !parseBool(item.value.compravel) && !parseBool(item.value.controlaEstoque)) {
    emit('show-notification', {
      message: 'Ao menos um dos campos (Comercializável, Comprável ou Controla Estoque) deve ser selecionado como SIM.',
      type: 'warning'
    })
    return
  }

  if (parseBool(item.value.comercializavel) && !item.value.idCategoriaFinanceiraEntrada) {
    formErrors.value.idCategoriaFinanceiraEntrada = 'Campo obrigatório para produtos comercializáveis.'
    emit('show-notification', {
      message: 'Para produtos comercializáveis, a "Categoria Financeira Padrão (Entradas/Receitas)" é obrigatória.',
      type: 'warning'
    })
    return
  } else {
    delete formErrors.value.idCategoriaFinanceiraEntrada
  }

  if (parseBool(item.value.compravel) && !item.value.idCategoriaFinanceiraSaida) {
    formErrors.value.idCategoriaFinanceiraSaida = 'Campo obrigatório para produtos compráveis.'
    emit('show-notification', {
      message: 'Para produtos compráveis, a "Categoria Financeira Padrão (Saídas/Despesas)" é obrigatória.',
      type: 'warning'
    })
    return
  } else {
    delete formErrors.value.idCategoriaFinanceiraSaida
  }

  const payload = montarPayload()

  const isNovo = !isEditing.value
  const idAnterior = item.value.idTipoProduto

  const sucesso = await submitForm('TiposProduto', 'idTipoProduto', payload)

  if (sucesso && item.value.idTipoProduto && (isNovo || idAnterior === item.value.idTipoProduto)) {
    const acao = isNovo ? 'cadastrado' : 'atualizado'
    emit('show-notification', {
      message: `Tipo de Produto '${item.value.descricaoBreve}' ${acao} com sucesso!`,
      type: 'success'
    })
    if (isNovo) {
      isTipoProdutoSaved.value = true
    }
  }
}

// --- Watch para carregar flag de bloqueio ao editar ---
watch(() => item.value.idTipoProduto, async (id) => {
  if (id && id > 0) {
    try {
      const res = await api.get(`/TiposProduto/${id}`)
      temProdutosVinculados.value = res.data.temProdutosVinculados || false
      isTipoProdutoSaved.value = true
    } catch (e) {
      console.warn('[TiposProdutoCadastro] Erro ao carregar flag de bloqueio:', e)
    }
  }
}, { immediate: true })

onMounted(() => {
  carregarListas()
  resolverPlanoCategoria()
})
</script>

<style scoped>
:deep(.form-label) { font-weight: 400 !important; }

:deep(.form-label[required]:not([required="false"])::after),
:deep(.form-label[required="true"])::after {
  content: " *"; color: #dc3545; font-weight: bold;
}

.pointer { cursor: pointer; }

.admin-table-container {
  background-color: transparent;
  border: 1px solid var(--bs-border-color);
  border-radius: 0.25rem;
  overflow-x: auto;
}
.admin-table thead th {
  background-color: var(--bs-tertiary-bg);
  color: var(--bs-heading-color);
  font-weight: 600;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid var(--bs-border-color);
}
.admin-table td {
  border-bottom: 1px solid var(--bs-border-color);
  color: var(--bs-body-color);
  padding: 0.75rem;
}

:deep(.campo-input-container), :deep(.campo-select-container) { margin-bottom: 1rem; display: flex; flex-direction: column; }
.acoes-cell { text-align: right; vertical-align: middle; }
.btn-icon { background: none; border: none; color: #6c7d8e; padding: 0.4rem; transition: 0.2s; }
.btn-icon:hover { color: #212934; }
[data-bs-theme="dark"] .btn-icon:hover { color: #fff; }

code.badge {
  font-family: var(--bs-font-monospace);
  letter-spacing: 0.5px;
}
</style>
